
TodoListItem = ({ attributes }: Component): VNode => {
  { value, changeItem as change, removeItem, editItem, editMode, completed, toggleComplete } = attributes

  hooks = { insert: (vnode) => {
      vnode.elm.focus()
      vnode.elm.select()
    } }

  // Styling based on completion status
  textDecoration = 'none'
  textOpacity = '1'
  if completed {
    textDecoration := 'line-through'
    textOpacity := '0.6'
  }

  textStyle = { padding: '10px', textDecoration, opacity: textOpacity, cursor: 'pointer', transition: 'all 0.2s ease' }

  borderColor = '#dee2e6'
  bgColor = 'white'
  if completed {
    borderColor := '#28a745'
    bgColor := '#d4edda'
  }

  borderStyle = '1px solid 'borderColor''

  cardStyle = { marginBottom: '10px', border: borderStyle, borderRadius: '5px', backgroundColor: bgColor,
    transition: 'all 0.2s ease' }

  <div class="card" style=cardStyle key=attributes.key>
    <div class="card-body" style={ padding: '10px' }>
      <div class="form-row align-items-center">
        <div class="col-auto">
          <input type="checkbox" checked=completed on={ change: toggleComplete } style={ width: '20px', height: '20px',
              cursor: 'pointer', accentColor: '#28a745' } />
        </div>
        <div class="col">
          if editMode {
            <input hooks class="form-control" type="text" value on={ change } />
          } else {
            <div on={ click: editItem } style=textStyle>
              if completed {
                <span class="badge badge-success" style={ marginRight: '10px' }>'✓'</span>
              }
              = value
              <span class="badge badge-secondary" style={ marginLeft: '10px', opacity: '0.7' }>'click to edit'</span>
            </div>
          }
        </div>
        <div class="col-auto">
          <button class="btn btn-danger btn-sm" on={ click: removeItem }>'🗑️'</button>
        </div>
      </div>
    </div>
  </div>
}
